var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0h56c6.627 0 12 5.373 12 12v56c0 6.627-5.373 12-12 12H12C5.373 80 0 74.627 0 68V12C0 5.373 5.373 0 12 0z",
    fill: "#0e71eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.031 26C21.801 26 20 27.822 20 30.063v14.843C20 49.388 23.601 53 28.063 53h20.156c2.23 0 4.031-1.822 4.031-4.063v-4.03l7.531 5.656c1.317.998 3.219.048 3.219-1.626V30.064c0-1.674-1.902-2.624-3.219-1.625l-7.531 5.656c0-4.482-3.601-8.094-8.063-8.094H24.032z",
    fill: "#fff"
  })));
}
export default SvgZoomIcon;